export default function HowWorkGoes() {
  const steps = [
    { num: '1', icon: 'ri-file-text-line', title: 'Вы оставляете заявку', desc: 'Заполните форму на сайте или свяжитесь удобным способом — телефон, Telegram, Email.' },
    { num: '2', icon: 'ri-phone-line', title: 'Созваниваемся', desc: 'В течение рабочего дня мы связываемся с вами для уточнения деталей и задач.' },
    { num: '3', icon: 'ri-search-eye-line', title: 'Изучаем задачи', desc: 'Проводим диагностику: интервью, анализ процессов, аудит KPI и воронки продаж.' },
    { num: '4', icon: 'ri-file-copy-2-line', title: 'Подготавливаем программу', desc: 'Разрабатываем индивидуальную программу под ваш бизнес, отрасль и цели компании.' },
    { num: '5', icon: 'ri-presentation-line', title: 'Проводим обучение', desc: 'Практический тренинг, внедрение инструментов и сопровождение до получения результата.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Как проходит работа
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Прозрачный процесс от первого обращения до измеримого результата. Никакой бюрократии — только практическая работа.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-teal-200"></div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5 lg:gap-4">
            {steps.map((step, i) => (
              <div key={i} className="relative text-center group">
                <div className="w-16 h-16 bg-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-lg group-hover:scale-110 transition-transform duration-300 relative z-10">
                  <span className="text-white text-xl font-extrabold">{step.num}</span>
                </div>
                <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <i className={`${step.icon} text-teal-600 text-lg`}></i>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>

                {i < steps.length - 1 && (
                  <div className="hidden lg:flex absolute top-8 -right-2 z-10 text-teal-400">
                    <i className="ri-arrow-right-s-line text-2xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}